import store from '@/store'
import { GET_SECURITY_DATA } from '@/store/getter-types'
import { SecurityArea, SecurityComponent } from '@/types/enums'
import { SecurityData } from '@/model/SecurityData'

export function isVisible(area: SecurityArea, component: SecurityComponent): boolean {
  const securityData: SecurityData[] = store.getters[GET_SECURITY_DATA]
  const filteredData: SecurityData[] = securityData.filter((item: SecurityData) => item.area === area)
  const foundData: SecurityData | undefined = filteredData.find((item: SecurityData) => (item.component === component))
  return foundData ? foundData.visibility : false
}

export function isDisabled(area: SecurityArea, component: SecurityComponent): boolean {
  const securityData: SecurityData[] = store.getters[GET_SECURITY_DATA]
  const filteredData: SecurityData[] = securityData.filter((item: SecurityData) => item.area === area)
  const foundData: SecurityData | undefined = filteredData.find((item: SecurityData) => (item.component === component))
  return foundData ? !foundData.enabled : false
}